import type { StaticLandingPage } from '../../../content';
import heroIcpBanner from './assets/hero-icp-banner.png';
import audienceCybersecurityTraining from './assets/audience-cybersecurity-training.jpg';
// Testimonials hidden per ACCS feedback (#15); imports retained (commented) for re-enable
// import testimonialRajeshKumar from './assets/testimonial-rajesh-kumar.jpg';
// import testimonialPriyaSharma from './assets/testimonial-priya-sharma.jpg';
// import testimonialArjunMenon from './assets/testimonial-arjun-menon.jpg';
// Trainers section hidden per ACCS feedback (#17); imports retained (commented) for re-enable
// import trainerVikramPatel from './assets/trainer-vikram-patel.jpg';
// import trainerAnanyaDesai from './assets/trainer-ananya-desai.jpg';
// import trainerSureshIyer from './assets/trainer-suresh-iyer.jpg';

export const academyInIcpPage = {
  slug: 'aca-in-icp',
  archetype: 'lead-gen',
  body: [
    {
      _uid: '68f696c8-7568-4b62-bd6c-ead4c8861d28',
      title: 'Industrial Cybersecurity Professional',
      variant: 'lead',
      subtitle: 'ICP Career Path — Industrial & OT Cybersecurity',
      component: 'hero_section',
      hero_image: {
        alt: 'Technician with a laptop in an industrial data center',
        filename: heroIcpBanner,
      },
      hero_stats: [
        { _uid: 'hero-chip-1', icon: 'groups', text: 'Face-to-face Training', component: 'icon_text_item' },
        { _uid: 'hero-chip-2', icon: 'schedule', text: '13 Days', component: 'icon_text_item' },
      ],
      highlights: [
        {
          _uid: '5e9a97b2-d8ed-4d8c-8089-bcbde6b516e8',
          icon: 'schedule',
          title: '5 Modules + Qualifier',
          component: 'icon_text_item',
        },
        {
          _uid: 'dbe32522-aeda-4907-bf08-6ee92046a1f0',
          icon: 'workspace_premium',
          title: 'TÜV SÜD Certification',
          component: 'icon_text_item',
        },
        {
          _uid: '4c769fed-991a-4832-8a00-a301a404c4ea',
          icon: 'verified_user',
          title: 'IEC 62443 Aligned',
          component: 'icon_text_item',
        },
        {
          _uid: '2bc7c160-92c4-4339-9bc4-e29194a3f676',
          icon: 'verified',
          title: 'Globally Recognized',
          component: 'icon_text_item',
        },
      ],
      description:
        'The TÜV SÜD Certified Industrial Cybersecurity Professional (ICP) Career Path is a comprehensive industrial and operational technology (OT) cybersecurity qualification for professionals securing ICS, SCADA, DCS, IIoT environments and critical infrastructure. Progress from cybersecurity foundation through defense, risk management, operations and architecture — aligned with IEC 62443 and industry best practices.',
      badge_1_text: 'New Batch Starting Soon',
      badge_2_text: 'TÜV SÜD Certification',
      academy_label: 'TÜV SÜD Academy',
      academy_link: 'https://www.tuvsud.com/en-in/store/academy-in',
      nav_cta_label: 'Request Callback',
      hero_image_alt: 'Technician with a laptop in an industrial data center',
      primary_cta_label: '',
      secondary_cta_label: 'Request a Callback',
    },
    /* Trust bar hidden per ACCS feedback (#6)
    {
      _uid: 'c1c47542-8a13-43f9-b1e0-d426031bec55',
      label: 'Trusted by Industry Leaders',
      partners: [
        {
          _uid: 'b0f83ea4-685e-4157-8340-017410a926ed',
          name: 'ISO 27001',
          label: 'ISO 27001 Certified',
          component: 'partner_item',
        },
        {
          _uid: 'acc5efd0-6a4b-452a-bbd5-f6762ae2ab94',
          name: 'CSA',
          label: 'Cloud Security Alliance',
          component: 'partner_item',
        },
        {
          _uid: '3486d32d-3bf0-407e-9081-53706135eceb',
          name: 'ISACA',
          label: 'ISACA Recognized',
          component: 'partner_item',
        },
        {
          _uid: '8805022f-fe24-4c24-a2d3-e55ac58e81ee',
          name: 'ISC2',
          label: 'ISC2 Partner',
          component: 'partner_item',
        },
      ],
      component: 'trust_bar_section',
    },
    */
    {
      _uid: 'c6551ccd-183f-41a7-920d-b0bf6e48dec4',
      title: 'Benefits That Set You Apart',
      eyebrow: 'Why Choose ICP',
      benefits: [
        {
          _uid: 'a4b061b7-a209-4c80-8d97-ccc3c22e8dc1',
          icon: 'trending_up',
          title: 'Structured Career Progression',
          component: 'icon_text_item',
          description:
            'Advance from beginner to advanced industrial cybersecurity practitioner along a structured pathway.',
        },
        {
          _uid: '489bb41f-c2ed-4824-8b8e-467b678032a9',
          icon: 'all_inclusive',
          title: 'Full Lifecycle Coverage',
          component: 'icon_text_item',
          description:
            'Comprehensive coverage of the industrial cybersecurity lifecycle — foundation, defense, risk, operations and architecture.',
        },
        {
          _uid: '977a6b26-bdd8-4646-9754-deb5f0050048',
          icon: 'verified_user',
          title: 'IEC 62443 Aligned',
          component: 'icon_text_item',
          description: 'Aligned with IEC 62443 and globally recognized OT cybersecurity frameworks.',
        },
        {
          _uid: '1f1661a3-ae8f-4905-a4da-16132e2fec82',
          icon: 'shield',
          title: 'Secure ICS, SCADA & IIoT',
          component: 'icon_text_item',
          description:
            'Enhanced capability to secure ICS, SCADA, DCS and IIoT environments against real-world industrial cyber threats.',
        },
        {
          _uid: '6f250709-8a6c-482d-aa76-213ecb5a4c17',
          icon: 'assessment',
          title: 'OT Risk & Reviews',
          component: 'icon_text_item',
          description: 'Improved ability to conduct OT risk assessments and industrial cybersecurity reviews.',
        },
        {
          _uid: '3f519f43-4c04-4040-9324-a210de8be967',
          icon: 'monitoring',
          title: 'OT SOC & Incident Response',
          component: 'icon_text_item',
          description:
            'Skills to support OT SOC operations, threat detection and incident response for industrial systems.',
        },
      ],
      component: 'benefits_section',
      description:
        'The ICP Career Path builds comprehensive industrial cybersecurity capabilities — from foundational knowledge through technical defense, risk management, operational security and architecture.',
    },
    {
      _uid: 'e86590a1-2094-47fe-be18-967fc5cdb59e',
      // Stats grid hidden per ACCS feedback (#10); only the CTA below is shown (#11)
      stats: [],
      cta_text: 'Join the league of TÜV SÜD certified industrial cybersecurity professionals',
      component: 'stats_section',
      cta_label: 'Start Your Journey — Enquire Now',
    },
    {
      _uid: '920d44a6-4add-4d6e-b18e-2b0b94d1e83b',
      title: '5 Modules + Qualifier',
      eyebrow: 'Curriculum',
      modules: [
        {
          _uid: 'e2d56eee-4b2b-4226-bb11-fd307488c1e9',
          icon: 'foundation',
          type: 'Mandatory',
          title: 'Industrial Cybersecurity Foundation Practitioner (ICFP)',
          number: '01',
          component: 'module_item',
          description:
            'Fundamentals of industrial cybersecurity: ICS, SCADA, DCS & PLC architecture, IT vs OT environments, industrial protocols, the threat landscape and an introduction to IEC 62443.',
        },
        {
          _uid: '9761750f-509f-4279-bd5b-7502b0ada050',
          icon: 'shield',
          type: 'Mandatory',
          title: 'Industrial Cybersecurity Defense Practitioner (ICDP)',
          number: '02',
          component: 'module_item',
          description:
            'Defense-in-depth architecture: network segmentation (zones & conduits), secure remote access, industrial firewalls, endpoint protection, system hardening, vulnerability management and OT network monitoring.',
        },
        {
          _uid: 'f8384449-be67-4911-aa96-33ba36e2646e',
          icon: 'assessment',
          type: 'Mandatory',
          title: 'Industrial Cybersecurity Risk Practitioner (ICRP)',
          number: '03',
          component: 'module_item',
          description:
            'OT risk assessment methodologies, asset inventory & criticality analysis, threat modeling, security levels, the IEC 62443 risk framework, compliance and supply-chain risk.',
        },
        {
          _uid: '3e637100-a329-4be4-8476-145224ad08be',
          icon: 'monitoring',
          type: 'Mandatory',
          title: 'Industrial Cybersecurity Operations Practitioner (ICOP)',
          number: '04',
          component: 'module_item',
          description:
            'OT Security Operations Center (SOC), security monitoring & detection, OT threat intelligence, incident response, cyber crisis management, digital forensics and business continuity.',
        },
        {
          _uid: '0467f4c9-1c7c-4100-8d43-c734e2a349fc',
          icon: 'architecture',
          type: 'Mandatory',
          title: 'Industrial Cybersecurity Architecture Practitioner (ICAP)',
          number: '05',
          component: 'module_item',
          description:
            'Secure industrial architecture design, Zero Trust for OT, IEC 62443 security program implementation, secure digital transformation, IIoT & cloud integration, advanced threat mitigation and OT governance.',
        },
        {
          _uid: 'ad5c6a28-e19b-4dbc-9702-bb4846156f5f',
          icon: 'emoji_events',
          type: 'Qualifier',
          heading: 'ICP Qualifier Examination',
          title: 'ICP Qualifier Examination',
          component: 'module_item',
          description:
            'Final qualifier exam across the full ICP Career Path — 50 multiple-choice questions, 60 minutes, 70% to pass (remotely proctored).',
        },
      ],
      footnote:
        'Each module ends with a remotely proctored online assessment. The ICP Qualification is awarded after completing all five modules and passing the final ICP Qualifier Examination; one free retake is available.',
      component: 'modules_section',
      cta_label: 'Get Detailed Curriculum',
      description:
        'A structured learning pathway from cybersecurity foundation through defense, risk management, operations and architecture — aligned with IEC 62443. Complete all five practitioner modules and pass the ICP Qualifier Examination to earn the ICP credential.',
    },
    {
      _uid: '82312024-4f19-4e75-9a6d-00e789a42133',
      image: {
        alt: 'Cybersecurity training session',
        filename: audienceCybersecurityTraining,
      },
      title: 'Who Should Attend?',
      eyebrow: 'Target Audience',
      audiences: [
        {
          _uid: 'ddbcbb4d-b8e4-4283-aa51-9ca7b8e4d45f',
          icon: 'engineering',
          title: 'OT Security Engineers',
          component: 'icon_text_item',
          description:
            'OT security engineers, industrial cybersecurity specialists and OT/security architects securing industrial environments.',
        },
        {
          _uid: 'b9cdfdfa-d52a-41a5-a484-9e95ed331500',
          icon: 'memory',
          title: 'ICS/SCADA & Automation Engineers',
          component: 'icon_text_item',
          description:
            'ICS/SCADA, automation, instrumentation and control system engineers responsible for industrial operations.',
        },
        {
          _uid: '92d0ffe0-39a8-4c63-98fe-1cd78517476f',
          icon: 'factory',
          title: 'Plant & Engineering Leaders',
          component: 'icon_text_item',
          description: 'Plant managers, technical and engineering managers, and reliability & maintenance engineers.',
        },
        {
          _uid: '8c847ed8-671d-4979-ad0d-e574270d455c',
          icon: 'security',
          title: 'IT Security Moving to OT',
          component: 'icon_text_item',
          description:
            'IT security professionals transitioning into OT security, plus network and infrastructure engineers.',
        },
        {
          _uid: '6e86bfd4-133d-45b6-9723-49946e8b9ede',
          icon: 'gavel',
          title: 'Risk, Compliance & Consultants',
          component: 'icon_text_item',
          description:
            'Risk and compliance professionals, cybersecurity consultants and industrial system integrators.',
        },
        {
          _uid: 'd6d9ebf1-a8d5-4a28-9a95-6a1be2842ba9',
          icon: 'hub',
          title: 'Critical Infrastructure & Digital Transformation',
          component: 'icon_text_item',
          description:
            'Critical infrastructure security personnel and digital transformation leaders protecting industrial operations.',
        },
      ],
      component: 'audience_section',
      cta_label: 'Enquire Now',
      image_alt: 'Industrial control room operations',
      description:
        'This program is designed for professionals across industrial operations, cybersecurity, engineering, digital transformation and critical infrastructure protection.',
    },
    /* Testimonials hidden per ACCS feedback (#15) — no alumni testimonials yet; re-enable once available
    {
      _uid: '6966b793-d9a3-46a6-b669-38c39dfdc8a9',
      title: 'What Our Alumni Say',
      eyebrow: 'Success Stories',
      variant: 'lead',
      component: 'testimonials_section',
      description:
        'Feedback from participants who used the ACCS programme to strengthen their cybersecurity expertise and career path.',
      testimonials: [
        {
          _uid: '2f08b83d-a9e9-42ac-8e9d-6b20a2141343',
          name: 'Rajesh Kumar',
          role: 'Security Analyst, Wipro',
          image: {
            alt: 'Rajesh Kumar',
            filename: testimonialRajeshKumar,
          },
          quote:
            'The ACCS program gave me a holistic view of cybersecurity that I never had before. The hands-on labs and the calibre of TÜV SÜD trainers were exceptional.',
          rating: 5,
          component: 'testimonial_item',
        },
        {
          _uid: 'ff180b76-a2e0-448b-b1a8-57705293ef70',
          name: 'Priya Sharma',
          role: 'IT Risk Manager, Infosys',
          image: {
            alt: 'Priya Sharma',
            filename: testimonialPriyaSharma,
          },
          quote: 'What sets ACCS apart is the breadth of coverage — from network security to AI & data privacy.',
          rating: 5,
          component: 'testimonial_item',
        },
        {
          _uid: '0fbd5e7a-c432-434c-898d-6a998915fb06',
          name: 'Arjun Menon',
          role: 'Cloud Security Lead, TCS',
          image: {
            alt: 'Arjun Menon',
            filename: testimonialArjunMenon,
          },
          quote: 'The cloud security and ISO 27001 modules were invaluable.',
          rating: 5,
          component: 'testimonial_item',
        },
      ],
    },
    */
    {
      _uid: '571e5008-887b-471a-b5f6-baa6a2672214',
      title: 'Learn From the Best',
      eyebrow: 'Expert Faculty',
      // Trainer profile cards removed per ACCS feedback; heading + description kept
      trainers: [],
      component: 'trainers_section',
      description:
        'Our trainers are industrial cybersecurity practitioners with deep OT, ICS/SCADA and IEC 62443 experience.',
    },
    {
      _uid: 'c735505d-a2ba-4f63-894d-86982ced7f64',
      title: 'Get Expert Guidance & a Callback',
      eyebrow: 'Get Started Today',
      component: 'form_section',
      provider: 'marketo',
      base_url: '//ts.tuvsud.com',
      munchkin_id: '819-PVY-502',
      form_id: 28959,
      anchor_id: 'form',
      form_title: 'Enquire Now',
      button_text: 'Get callback',
      inline_success: true,
      success_title: 'Thank you! We have received your details.',
      success_text:
        'Our training advisor will reach out to you shortly with batch schedules, fees and the next steps.',
      trust_title: 'Your information is safe with us',
      trust_text: 'We respect your privacy. No spam, ever.',
      privacy_policy_url: 'https://www.tuvsud.com/en-in/store/academy-in/privacy-policy',
      terms_url: 'https://www.tuvsud.com/en-in/terms-and-conditions',
      description:
        'Fill in your details and our training advisor will contact you with a personalized learning plan, batch schedules, and exclusive pricing.',
      value_points: [
        {
          _uid: 'df8d3eae-9f19-4d60-9d6b-b3c5836f3dab',
          icon: 'calendar_month',
          title: 'Upcoming batch schedules & training calendar',
          component: 'icon_text_item',
        },
        {
          _uid: 'a65d8a87-de7b-4049-ad93-77709f3cdc36',
          icon: 'local_offer',
          title: 'Exclusive pricing for early registrations',
          component: 'icon_text_item',
        },
        {
          _uid: '05f55ad5-1e11-434f-9a3e-0d1ebb49078d',
          icon: 'support_agent',
          title: 'Free 1-on-1 career counselling session',
          component: 'icon_text_item',
        },
      ],
    },
    {
      _uid: 'a8e95182-a4dc-4158-981a-5fe5debf82f6',
      faqs: [
        {
          _uid: '3d49e119-ab9f-47ed-8133-3778a960a57e',
          answer:
            "The ICP Career Path is TÜV SÜD's structured industrial cybersecurity certification program designed to develop competencies across industrial cybersecurity fundamentals, defense, risk management, operations and architecture.",
          question: 'What is the ICP Career Path?',
          component: 'faq_item',
        },
        {
          _uid: '9104dc5e-952c-4f21-8e68-29442ac336f1',
          question: 'How many certifications are included in the ICP Career Path?',
          answer: 'Five module certifications (ICFP, ICDP, ICRP, ICOP, ICAP), followed by the ICP Qualifier Exam.',
          answer_blocks: [
            {
              type: 'paragraph',
              text: 'The program includes five certifications, followed by the ICP Qualifier Exam:',
            },
            {
              type: 'list',
              items: [
                'Industrial Cybersecurity Foundation Professional (ICFP)',
                'Industrial Cybersecurity Defense Professional (ICDP)',
                'Industrial Cybersecurity Risk Professional (ICRP)',
                'Industrial Cybersecurity Operations Professional (ICOP)',
                'Industrial Cybersecurity Architecture Professional (ICAP)',
              ],
            },
          ],
          component: 'faq_item',
        },
        {
          _uid: '0343fe36-ab72-4915-ab0c-0fcecfec89e4',
          answer:
            'No. A basic understanding of industrial systems, engineering, IT or cybersecurity concepts is recommended, but advanced cybersecurity experience is not mandatory to begin the ICP Career Path.',
          question: 'Is prior cybersecurity experience mandatory?',
          component: 'faq_item',
        },
        {
          _uid: 'f3a9c1e4-2b7d-4c8a-9e51-6d0b3a4f7c2e',
          question: 'Which industries can benefit from this certification?',
          answer:
            'Manufacturing, power & energy, oil & gas, chemicals, pharmaceuticals, utilities, transportation, water & wastewater, smart infrastructure and other critical infrastructure sectors.',
          answer_blocks: [
            { type: 'paragraph', text: 'The program is relevant for:' },
            {
              type: 'list',
              items: [
                'Manufacturing',
                'Power & Energy',
                'Oil & Gas',
                'Chemicals',
                'Pharmaceuticals',
                'Utilities',
                'Transportation',
                'Water & Wastewater',
                'Smart Infrastructure',
                'Critical Infrastructure sectors',
              ],
            },
          ],
          component: 'faq_item',
        },
        {
          _uid: 'b7e3a1d2-9c4f-4a1b-8e6d-1f2a3b4c5d6e',
          answer:
            'The course is available as classroom or virtual training. The virtual option is a live, instructor-led (VILT) session where you can interact with the trainer — pre-recorded videos are not available.',
          question: 'What are the modes of training?',
          component: 'faq_item',
        },
        {
          _uid: 'a1b2c3d4-e5f6-4a7b-8c9d-1e2f3a4b5c6d',
          answer:
            'Each module ends with a remotely proctored online exam (50 multiple-choice questions, 60 minutes, 70% to pass). You receive an individual TÜV SÜD certificate per module, and the ICP Qualification is awarded after passing all module exams and the final ICP Qualifier Examination.',
          question: 'How are participants assessed and certified?',
          component: 'faq_item',
        },
        {
          _uid: 'b2c3d4e5-f6a7-4b8c-9d1e-2f3a4b5c6d7e',
          answer:
            'Yes. Candidates who do not pass the online examination are allowed one retake at no cost — contact your TÜV SÜD representative to arrange it.',
          question: 'Can I retake the online exam?',
          component: 'faq_item',
        },
        {
          _uid: 'c3d4e5f6-a7b8-4c9d-1e2f-3a4b5c6d7e8f',
          answer:
            'Training dates are published in advance. For exclusive in-house training on your preferred dates, email training.in@tuvsud.com.',
          question: 'Can the training dates be customized?',
          component: 'faq_item',
        },
        {
          _uid: 'd4e5f6a7-b8c9-4d1e-2f3a-4b5c6d7e8f90',
          answer:
            'ICP develops specialized OT and industrial cybersecurity competencies increasingly required across critical infrastructure, manufacturing, energy and industrial digital transformation. It demonstrates capability across the complete industrial cybersecurity lifecycle and supports advancement into specialist, consulting, architecture, governance and leadership roles.',
          question: 'How will ICP help my career?',
          component: 'faq_item',
        },
      ],
      title: 'Frequently Asked Questions',
      eyebrow: 'FAQ',
      variant: 'lead',
      component: 'faq_section',
      bottom_text: 'Still have questions? Our training advisors are happy to help!',
      description: 'Important questions about course structure, eligibility, scheduling, and advisor support.',
      whatsapp_url: {
        id: '',
        url: 'https://wa.me/917391930118?text=Hi%2C%20I%20have%20a%20question%20about%20the%20ICP%20program',
        target: '_blank',
        linktype: 'url',
        fieldtype: 'multilink',
        cached_url: 'https://wa.me/917391930118?text=Hi%2C%20I%20have%20a%20question%20about%20the%20ICP%20program',
      },
      contact_title: 'Still have questions?',
      accordion_label: 'Frequently Asked Questions',
      advisor_cta_label: 'Talk to an Advisor',
      whatsapp_cta_label: 'Chat on WhatsApp',
      contact_description: 'Our advisors can help you evaluate the right module path, fees, and upcoming intake dates.',
    },
    {
      _uid: '3c1f2818-013a-4588-8942-56a8e165f23b',
      variant: 'lead',
      component: 'footer_section',
      about_text:
        "TÜV SÜD is one of the world's leading technical service organizations with over 150 years of domain expertise. TÜV SÜD Academy offers world-class training and certification programs.",
      legal_links: [
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/en-in/-/media/regions/in/pdf-files/terms-and-conditions/standard-terms--conditions-for-estore-academy.pdf',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url:
              'https://www.tuvsud.com/en-in/-/media/regions/in/pdf-files/terms-and-conditions/standard-terms--conditions-for-estore-academy.pdf',
          },
          _uid: 'a6f1c2d4-8e3b-4f1a-9c7d-2b5e0a4f1d10',
          label: 'Terms and Condition',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/en-in/store/academy-in/cancellation-policy',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.tuvsud.com/en-in/store/academy-in/cancellation-policy',
          },
          _uid: 'b7e2d3f5-9f4c-4a2b-8d6e-3c6f1b5a2e21',
          label: 'Cancellation Policy',
          component: 'link_item',
        },
      ],
      quick_links: [
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/en-in/store/academy-in',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.tuvsud.com/en-in/store/academy-in',
          },
          _uid: '8b4d6b7b-27c0-42a2-b752-2e262cc86517',
          label: 'Academy Store',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/en-in/store/academy-in/sectors/information-technology',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.tuvsud.com/en-in/store/academy-in/sectors/information-technology',
          },
          _uid: '130b5d19-6997-4fa8-bcec-968fd02667f4',
          label: 'Cyber Security Training',
          component: 'link_item',
        },
      ],
      social_links: [
        {
          url: {
            id: '',
            url: 'https://www.linkedin.com/company/tuvsud/',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.linkedin.com/company/tuvsud/',
          },
          _uid: '615150b9-9de7-4462-a597-fdee3e8587db',
          label: 'LinkedIn',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.youtube.com/TUVSUD',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.youtube.com/TUVSUD',
          },
          _uid: 'cf43553f-e217-4a5d-9749-943d6d424f87',
          label: 'YouTube',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.facebook.com/tuvsud',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.facebook.com/tuvsud',
          },
          _uid: '14205c9b-459f-44e5-b5e5-b7e3281e9684',
          label: 'Facebook',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.instagram.com/tuvsud/',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.instagram.com/tuvsud/',
          },
          _uid: 'd84226e4-e164-4cc8-994d-ac3817a29241',
          label: 'Instagram',
          component: 'link_item',
        },
      ],
      contact_email: 'academy.in@tuvsud.com',
      contact_phone: '+91 22 6274 5000',
      copyright_text: '© 2026 TÜV SÜD. All rights reserved.',
      contact_address: 'TÜV SÜD South Asia,\nMumbai, Maharashtra, India',
      primary_column_label: 'Quick Links',
      secondary_column_label: 'Contact India',
    },
    {
      _uid: '23ec3496-3e62-4b7c-b25d-d2ad28309a68',
      title: 'TÜV SÜD Certified Industrial Cybersecurity Professional (ICP)',
      subtitle: '— New Batch Starting Soon!',
      component: 'sticky_cta_bar',
      cta_label: 'Enquire Now',
    },
    {
      _uid: '02861604-0d1a-457d-8093-1ef870be6344',
      enabled: true,
      qr_hint: 'Or scan with your phone',
      component: 'whatsapp_widget',
      nudge_text: 'Need help? Chat with us!',
      header_title: 'TÜV SÜD India',
      bubble_line_1: 'Hi there! Interested in the Industrial Cybersecurity Professional (ICP) Career Path?',
      bubble_line_2: 'Chat with us for instant answers about the programme, fees, schedule & more.',
      open_cta_label: 'Open WhatsApp Chat',
      header_subtitle: 'Course Counsellor',
      reply_time_text: 'Typically replies within minutes',
      whatsapp_number: '917391930118',
      prefilled_message:
        "Hi, I'm interested in the TÜV SÜD Certified Industrial Cybersecurity Professional (ICP) Career Path. Could you share more details?",
    },
  ],
} satisfies StaticLandingPage;
